const userTypes= {
    LOGIN_STATUS:"LOGIN_STATUS",
};

export default userTypes;